import { useState } from "react";
import { faqList } from "@/mocks/trending";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16 lg:px-14">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-foreground-600">
            <i className="ri-question-line text-primary-500" aria-hidden="true"></i> FAQ
          </p>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">常见问题</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-500">
            关于内容更新、数据口径、投稿与合作，最常被问到的问题都在这儿。没找到答案？欢迎通过底部表单留言告诉我们。
          </p>
          <a href="#subscribe" className="mt-5 inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-700 hover:text-primary-800">
            向我们提问 <i className="ri-chat-3-line text-base" aria-hidden="true"></i>
          </a>
        </div>

        <div className="lg:col-span-8">
          <div className="flex flex-col gap-3">
            {faqList.map((f, i) => {
              const isOpen = openIdx === i;
              return (
                <div key={i} className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
                  <button
                    onClick={() => setOpenIdx(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className={`text-base font-semibold ${isOpen ? "text-primary-700" : "text-foreground-950"}`}>{f.q}</span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"}`}>
                      <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`} aria-hidden="true"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5">
                      <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}